import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { UserService } from '../services/user.service';
import { PromotionService } from '../services/promotion.service';
import { AdminService } from '../services/admin.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-promotion',
  templateUrl: './promotion.component.html'
})
export class PromotionComponent implements OnInit, OnDestroy {

  message: string = ''
  prize: string = ''
  timeout: any = null
  promotionContent: any
  subscription: Subscription
  isLoggedIn: Boolean = false
  isPromoAlt: Boolean = false
  noNav: Boolean = false

  constructor(
	private router: Router,
	private activatedRoute: ActivatedRoute,
	private userService: UserService,
	private promotionService: PromotionService,
	private adminService: AdminService
  ) {
	this.router.events.filter((event) => event instanceof NavigationEnd).map(() => this.activatedRoute).map((route) => {
	  this.isLoggedIn = this.userService.isLoggedin()
	  while (route.firstChild) route = route.firstChild
	  return route;
  }).filter((route) => route.outlet === 'primary').mergeMap((route) => route.data).subscribe((event) => {
	  this.noNav = false
	  if (event['noNav'])  {
		  this.noNav = true
	  }
	  if (event['promoAlt'])  {
		this.isPromoAlt = true
	  } else {
		this.isPromoAlt = false
	  }
  });
  }

  ngOnInit() {
	this.getPromotionStripContent()

	this.subscription = this.promotionService.promoMessageChanged.subscribe((res: any) => {
	  const msg = res[0].msg
		if (msg === 'Details updated successfully') {
		if (res[0].obj.content.displayPromotionStrip) {
		  this.promotionContent = res[0].obj.content
		} else {
		  this.promotionContent = null
		}
	  }
	})
  }

  ngOnDestroy() {
	if (this.subscription) {
	  this.subscription.unsubscribe()
	}
  }

  onClose() {
	document.getElementById('promotion-comp').style.display = 'none'
	localStorage.setItem('promotion-closed', JSON.stringify(true))
	this.promotionService.closeMessage()
  }

  getPromotionStripContent() {
	  this.adminService.getStaticContent('promotion-strip').then((res: any) => {
	  if (res.content.displayPromotionStrip) {
		this.promotionContent = res.content
	  } else {
		this.promotionContent = null
	  }
	  setTimeout(() => {
		let isLoggedIn = this.userService.isLoggedin()
		if (isLoggedIn) {
		  if (localStorage.getItem('promotion-closed') === 'true') {
			document.getElementById('promotion-comp').style.display = 'none'
		  } else {
			document.getElementById('promotion-comp').style.display = 'block'
		  }
		} else {
		  if (localStorage.getItem('promotion-closed') === 'true') {
			document.getElementById('promotion-comp').style.display = 'none'
			// Display it again after 1 hour
			if (!this.timeout) {
			  this.timeout = setTimeout(() => {
				document.getElementById('promotion-comp').style.display = 'block'
				localStorage.setItem('promotion-closed', JSON.stringify(false))
			  }, 1 * 60 * 60 * 1000);
			}
		  } else {
			document.getElementById('promotion-comp').style.display = 'block'
		  }
		}
	  }, 500);
	}).catch (err => {
	  console.log('Error getting static content')
	  console.log(err);
	})
  }

}



// WEBPACK FOOTER //
// ./src/app/promotion/promotion.component.ts